function getUTC(date) {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
}

function getDateParams(dateString) {
  let dateParams = dateString.split(',');
  dateParams[1] = dateParams[1] - 1;
  return dateParams;
}

const toLocalDate = (dateString, origin) => {
  if (!dateString) return null;

  let dateParams = getDateParams(dateString); // [Y, m, d, H, i, s]
  let date = new Date(...dateParams); // дата создания комментария (по серверному времени)

  console.log('по серверному времени (по москве )', date)

  origin = origin ? parseInt(origin) : Date.parse(date);
  let utcDiff = date - origin; // разница даты создания с UTC (по серверному времени)

  console.log('origin', origin, new Date(origin))
  console.log('utc diff', utcDiff)

  let now = new Date();
  let localDiff = Date.parse(now) - getUTC(now); // разница локальной даты с UTC

  console.log('local', now, new Date(getUTC(now)))
  console.log('local diff', localDiff)

  let offset = localDiff - utcDiff; // разница между локальной датой и серверной датой создания комментария
  console.log('offset', offset)

  date = new Date(Date.parse(date) + offset); // дата создания комментария в локальном формате

  console.log(new Date(...dateParams), date);
  console.log('******')

  return date;
}

export { toLocalDate };